import React from 'react';
import { Box, Button, Grid, TextField, Typography } from '@mui/material';
import { IDocument } from '../../../../../../Interfaces/IDocument';
import { DocumentOverview } from '../../../../../Document/DocumentOverview';
import { IMortgage } from '../../../../../../Interfaces/IMortgage';

interface IProps {
  handleBack: Function;
  handleNext: Function;
  mortgageObject: IMortgage;
  setMortgageObject: Function;
  documentArray: IDocument[];
  setDocumentArray: Function;
  title: string;
  getMortgageDocuments?: boolean;
}

export const MortgageDocuments: React.FC<IProps> = ({
  handleBack,
  handleNext,
  mortgageObject,
  setMortgageObject,
  documentArray,
  setDocumentArray,
  title,
  getMortgageDocuments = false,
}) => {
  const { ToBeDeleted, BeneficiaryType } = mortgageObject;

  return (
    <>
      <Typography variant='h4' mt={6} mb={6}>
        {title}
      </Typography>
      {getMortgageDocuments ? (
        <Typography variant='body1'>
          Bitte laden Sie die <b>Grundschulddokumente</b>, falls vorhanden,
          hoch. (Löschungsdokument von der Bank / erstellungsdokument von der
          Bank)
        </Typography>
      ) : (
        <>
          {BeneficiaryType === 'institution' && (
            <Typography variant='body1'>
              Bitte laden Sie das <b>Grundschuldformular</b> und den{' '}
              <b>Notarauftrag</b> hoch.
            </Typography>
          )}
          {BeneficiaryType === 'private' && (
            <Typography variant='body1'>Bitte laden Sie das.</Typography>
          )}
          {ToBeDeleted && (
            <>
              <Typography variant='body1' mb={2}>
                Bitte laden Sie hier weitere Dokumente hoch, die Sie zur
                Löschung der Grundschuld erhalten haben
              </Typography>
            </>
          )}
        </>
      )}

      <DocumentOverview
        allowRemove
        allowUpload
        documentArray={documentArray}
        setDocumentArray={setDocumentArray}
        title=''
      />

      {!getMortgageDocuments && (
        <>
          <Typography mt={6} mb={2}>
            Haben Sie weitere Anmerkungen, Anregungen oder Wünsche zum
            Beurkungungsauftrag?
          </Typography>
          <Grid item xs={6} sm={4}>
            <TextField
              label='Anmerkungen'
              fullWidth
              size='small'
              multiline
              rows={5}
              value={mortgageObject.Remarks}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                setMortgageObject({
                  ...mortgageObject,
                  Remarks: event.target.value,
                })
              }
            />
          </Grid>
        </>
      )}

      <Box mt={6} sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
        <Button variant='outlined' onClick={() => handleBack()} sx={{ mr: 1 }}>
          Zurück
        </Button>
        <Box sx={{ flex: '1 1 auto' }} />
        <Button type='submit' variant='contained' onClick={() => handleNext()}>
          Weiter
        </Button>
      </Box>
    </>
  );
};
